export const minWidthDecorator = (node: HTMLElement | null) => {
  if (node !== null) {
    const originalWidth = node.getBoundingClientRect().width
    // eslint-disable-next-line no-param-reassign
    node.style.minWidth = node.getBoundingClientRect().width > 44 ? '44px' : `${originalWidth}px`
  }
}

export default minWidthDecorator
